import clsx from 'clsx'
import Head from 'next/head'
import React from 'react'

import { Header as BaseHeader } from 'components/Header'

import type { ComponentType } from 'react'

export interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  hasHeader?: boolean
  headerHasBackButton?: boolean
  headerTitle?: string
  hasBottomNav?: boolean
  backHref?: string
  header?: ComponentType
}

export const Layout = ({
  children,
  hasHeader = false,
  headerTitle = '',
  headerHasBackButton = false,
  className,
  header: PropHeader,
}: LayoutProps) => {
  const Header =
    PropHeader ??
    (() =>
      BaseHeader({ title: headerTitle, hasBackButton: headerHasBackButton }))

  return (
    <>
      <Head>
        <link rel="shortcut icon" href="/video-inspirasi/favicon.ico" />
      </Head>
      <div
        className={clsx(
          'max-w-xl m-auto relative',
          hasHeader && 'mt-14',
          className
        )}
        style={{
          minHeight: 'calc(100vh - 3.5rem)',
        }}
      >
        {hasHeader && <Header />}
        <div className="h-full">{children}</div>
      </div>
    </>
  )
}

export default Layout
